import React, { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import Product from './Product';
import { IProduct } from '../../../../../interfaces/product';
import { useDefineUserRole } from '../../../../../hooks';
import { IUser } from '../../../../../interfaces/user';

const useStyles = makeStyles()(theme => {
  return {
    container: {
      display: 'grid',
      gap: 19,
      gridTemplateColumns: 'repeat(5, 1fr)',
      [theme.breakpoints.down(1500)]: {
        gridTemplateColumns: 'repeat(4, 1fr)',
      },
      [theme.breakpoints.down(1350)]: {
        gridTemplateColumns: 'repeat(3, 1fr)',
      },
      [theme.breakpoints.down(1200)]: {
        // gap: 10,
        gridTemplateColumns: 'minmax(235px,1fr) minmax(245px,1fr);',
      },
      [theme.breakpoints.down(920)]: {
        gridTemplateColumns: 'repeat(3, 1fr)',
      },
      [theme.breakpoints.down(630)]: {
        gap: 8,
        gridTemplateColumns: 'minmax(150px,1fr) minmax(150px,1fr);',
      },

      [theme.breakpoints.down(400)]: {
        gridTemplateColumns: 'minmax(150px,1fr);',
      },
    },
    productCard: {
      minWidth: '100%',
      marginBottom: 25,
      cursor: 'pointer',
      transition: '.3s ease-out',
      boxShadow: 'none !important',

      '&:hover': {
        transform: 'scale(1.03)',
      },

      [theme.breakpoints.up('md')]: {
        width: 220,
      },
    },
  };
});
interface IProductsProps {
  data: IProduct[];
  me: IUser | undefined;
  companyId?: number;
}

const ProductsGrid: FC<IProductsProps> = ({ data, me, companyId }) => {
  const classes1 = useStyles();
  const { classes } = classes1;
  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR', 'ROLE_VENDOR_STAFF']);

  return (
    <>
      <div className={classes.container}>
        {data.map(item => {
          return (
            <Product
              key={item.id}
              me={me}
              item={item}
              prices={
                isVendor || me?.is_admin
                  ? item.prices_values?.find(i => i.vendor?.id === companyId)?.prices
                  : undefined
              }
            />
          );
        })}
      </div>
    </>
  );
};

export default ProductsGrid;
